import { render, staticRenderFns } from "./DiagramChooseNumber.vue?vue&type=template&id=7acd9766&"
import script from "./DiagramChooseNumber.vue?vue&type=script&lang=js&"
export * from "./DiagramChooseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports